import axios from "axios";

const commonInterceptor = (instance) => {
  instance.interceptors.request.use(
    (config) => {
      const partnerRole = localStorage.getItem("partnerRole");

      const partnerType = localStorage.getItem("partnerType")?.toLowerCase();
      const partnerRoleNew = localStorage.getItem("partnerRoleNew")?.toLowerCase();
      const identifyFlag = sessionStorage.getItem("identifyFlag");

      // const isPartner =
      //   partnerType === "partner" ||
      //   partnerRoleNew === "partner";

      const token =
        partnerRoleNew === "partner" && identifyFlag
          ? localStorage.getItem("partnerSsoToken")
          : localStorage.getItem("ssoToken");

      const permissions = localStorage.getItem("permissions");

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // config.headers["Content-Type"] =isPartner
      //   ? "text/plain" : "application/json";

        config.headers["Content-Type"] = "application/json";

      if (permissions) {
        config.headers.Perm = permissions;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );
};

const axiosInstance = axios.create({
  headers: {
    reserv: 1,
  },
});

commonInterceptor(axiosInstance);


export const axiosInstance0 = axios.create({
  headers: {
    reserv: 0,
  },
});

commonInterceptor(axiosInstance0);

export const axiosPlainInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

axiosPlainInstance.interceptors.request.use(
  (config) => {
    const permissions = localStorage.getItem("permissions");

    if (permissions) {
      config.headers.Perm = permissions;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const axiosMultipartInstance = axios.create({
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

axiosMultipartInstance.interceptors.request.use(
  (config) => {
    const partnerRole = localStorage.getItem("partnerRole");

    const token =
      partnerRole === "Partner"
        ? localStorage.getItem("partnerSsoToken")
        : localStorage.getItem("ssoToken");

    const permissions = localStorage.getItem("permissions");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (permissions) {
      config.headers.Perm = permissions;
    }

    return config;
  },
  (error) => Promise.reject(error)
);


export const axiosReserve1PlainInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    reserv: 1,
  },
});

axiosReserve1PlainInstance.interceptors.request.use(
  (config) => {
    const permissions = localStorage.getItem("permissions");

    if (permissions) {
      config.headers.Perm = permissions;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const axiosFormDataInstance = axios.create();

axiosFormDataInstance.interceptors.request.use(
  (config) => {
    const partnerRole = localStorage.getItem("partnerRole");

    const token =
      partnerRole === "Partner"
        ? localStorage.getItem("partnerSsoToken")
        : localStorage.getItem("ssoToken");

    const permissions = localStorage.getItem("permissions");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (permissions) {
      config.headers.Perm = permissions;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const axiosMultipart1 = axios.create({
  headers: {
    "Content-Type": "multipart/form-data",
    reserv: 1,
  },
});

axiosMultipart1.interceptors.request.use(
  (config) => {
    const partnerRole = localStorage.getItem("partnerRole");

    const token =
      partnerRole === "Partner"
        ? localStorage.getItem("partnerSsoToken")
        : localStorage.getItem("ssoToken");

    const permissions = localStorage.getItem("permissions");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (permissions) {
      config.headers.Perm = permissions;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;